/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const PaymentProcessStatusErrorsInnerCategoryEnum = {
    AbandonedUserAction: 'abandoned_user_action',
    AuthenticationRequired: 'authentication_required',
    BankDecline: 'bank_decline',
    BankNotAvailable: 'bank_not_available',
    CardNotAccepted: 'card_not_accepted',
    CurrencyIssue: 'currency_issue',
    CvvRequired: 'cvv_required',
    ExceededLimit: 'exceeded_limit',
    ExpiredCard: 'expired_card',
    Fraud: 'fraud',
    IncorrectDataBillingAddress: 'incorrect_data_billing_address',
    IncorrectDataBillingCountry: 'incorrect_data_billing_country',
    IncorrectDataBillingName: 'incorrect_data_billing_name',
    IncorrectDataBillingZipCode: 'incorrect_data_billing_zip_code',
    IncorrectDataCardholder: 'incorrect_data_cardholder',
    IncorrectDataCardNumber: 'incorrect_data_card_number',
    IncorrectDataCvv: 'incorrect_data_cvv',
    IncorrectDataDateCvv: 'incorrect_data_date_cvv',
    IncorrectDataExpirationDate: 'incorrect_data_expiration_date',
    InsufficientFunds: 'insufficient_funds',
    ProcessingError: 'processing_error',
    Timeout: 'timeout'
};
/**
 * @export
 */
export const PaymentProcessStatusErrorsInnerRecommendationEnum = {
    NotAvailable: 'not_available',
    AdjustTheLimit: 'adjust_the_limit',
    ChangeCurrency: 'change_currency',
    CheckBillingAddress: 'check_billing_address',
    CheckWithBank: 'check_with_bank',
    DifferentCard: 'different_card',
    DifferentPaymentMethod: 'different_payment_method',
    IncorrectDataCardNumber: 'incorrect_data_card_number',
    IncorrectDataCardholder: 'incorrect_data_cardholder',
    IncorrectDataCvv: 'incorrect_data_cvv',
    IncorrectDataDateCvv: 'incorrect_data_date_cvv',
    IncorrectDataExpirationDate: 'incorrect_data_expiration_date',
    InsufficientFunds: 'insufficient_funds',
    TryAgain: 'try_again',
    TryAgainLater: 'try_again_later'
};
/**
 * Check if a given object implements the PaymentProcessStatusErrorsInner interface.
 */
export function instanceOfPaymentProcessStatusErrorsInner(value) {
    if (!('category' in value) || value['category'] === undefined)
        return false;
    return true;
}
export function PaymentProcessStatusErrorsInnerFromJSON(json) {
    return PaymentProcessStatusErrorsInnerFromJSONTyped(json, false);
}
export function PaymentProcessStatusErrorsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'category': json['category'],
        'description': json['description'] == null ? undefined : json['description'],
        'paymentId': json['payment_id'] == null ? undefined : json['payment_id'],
        'recommendation': json['recommendation'] == null ? undefined : json['recommendation'],
    };
}
export function PaymentProcessStatusErrorsInnerToJSON(json) {
    return PaymentProcessStatusErrorsInnerToJSONTyped(json, false);
}
export function PaymentProcessStatusErrorsInnerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'category': value['category'],
        'description': value['description'],
        'payment_id': value['paymentId'],
        'recommendation': value['recommendation'],
    };
}
